import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Skeleton } from '@vk-hr-tek/ui/Skeleton';

import { NotificationItemSkeleton } from '../NotificationItemSkeleton';

const NUMBER_OF_NOTIFICATIONS = 3;

export const BellNotificationsSkeleton = () => {
  const notifications = new Array(NUMBER_OF_NOTIFICATIONS)
    .fill('')
    .map((_, index) => <NotificationItemSkeleton key={index} />);

  return (
    <Box display="flex" flexDirection="column" gap="8" px="8">
      <Box>
        <Skeleton variant="rect" height={20} width={144} />
      </Box>
      {notifications}
    </Box>
  );
};
